import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { updateCustomRange } from "../redux/activitiesSaga";
import { useDispatch, useSelector } from "react-redux";

const CustomDateRanges = () => {
  const dispatch = useDispatch();
  let selectedRangeOption = useSelector((state) => state.activities.selectedRangeOption);
  let rangeOptions = useSelector((state) => state.activities.rangeOptions);
  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.activities.currentUser
  );

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={(data) =>
        dispatch(updateCustomRange({ data, calendarStartDate, calendarEndDate }))
      }
    />
  );
};

export default CustomDateRanges;
